(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (() => {
    const preservePreview = (value) => {
      const next = new URL(value, window.location.href);
      const current = new URL(window.location.href);
      ['preview_theme_id'].forEach((key) => {
        if (current.searchParams.has(key)) next.searchParams.set(key, current.searchParams.get(key));
      });
      return next.href;
    };

    const cardKey = (card) => new URL(card.getAttribute('href') || card.href, window.location.href).pathname;

    const initialize = (root) => {
      if (root.dataset.infiniteReady === 'true' || !('IntersectionObserver' in window)) return;

      const grid = root.querySelector('[data-infinite-grid]');
      const loader = root.querySelector('[data-infinite-loader]');
      const link = root.querySelector('[data-infinite-next]');
      const sentinel = root.querySelector('[data-infinite-sentinel]');
      const status = root.querySelector('[data-infinite-status]');
      if (!grid || !loader || !link || !sentinel || !status) return;

      root.dataset.infiniteReady = 'true';
      root.classList.add('is-enhanced');

      const knownCards = new Set(
        Array.from(grid.querySelectorAll('.orion-sleep-diary__card[href]')).map(cardKey)
      );
      let nextUrl = preservePreview(link.href);
      let loading = false;
      let observer;

      const complete = () => {
        observer.disconnect();
        loader.remove();
      };

      const loadNext = async () => {
        if (loading || !nextUrl) return;
        loading = true;
        root.setAttribute('aria-busy', 'true');
        status.textContent = 'Φόρτωση περισσότερων άρθρων';

        try {
          const response = await fetch(nextUrl, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`Request failed: ${response.status}`);

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextRoot = documentFragment.querySelector('[data-orion-infinite]');
          const nextGrid = nextRoot && nextRoot.querySelector('[data-infinite-grid]');
          if (!nextGrid) throw new Error('Article grid not found');

          let added = 0;
          nextGrid.querySelectorAll('.orion-sleep-diary__card[href]').forEach((card) => {
            const key = cardKey(card);
            if (knownCards.has(key)) return;
            knownCards.add(key);
            grid.appendChild(document.importNode(card, true));
            added += 1;
          });

          const nextLink = nextRoot.querySelector('[data-infinite-next]');
          status.textContent = `Προστέθηκαν ${added} άρθρα`;
          if (nextLink) {
            nextUrl = preservePreview(nextLink.getAttribute('href') || nextLink.href);
            link.href = nextUrl;
          } else {
            nextUrl = '';
            complete();
          }
        } catch (error) {
          root.classList.remove('is-enhanced');
          root.classList.add('has-infinite-error');
          link.href = nextUrl;
          status.textContent = 'Η αυτόματη φόρτωση διακόπηκε. Χρησιμοποιήστε τον σύνδεσμο για περισσότερα άρθρα.';
          observer.disconnect();
        } finally {
          root.removeAttribute('aria-busy');
          loading = false;
        }
      };

      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadNext();
      }, { rootMargin: '900px 0px' });
      observer.observe(sentinel);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-orion-infinite]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-collection-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSeriesNavigation = (root) => {
      const nav = root.querySelector('[data-orion-series-nav]');
      const track = root.querySelector('[data-orion-series-track]');
      if (!nav || !track || track.dataset.orionSeriesReady === 'true') return;

      const activeLink = track.querySelector('.is-active');

      const centerActiveLink = () => {
        if (!activeLink || track.scrollWidth <= track.clientWidth) return;
        const target = activeLink.offsetLeft - ((track.clientWidth - activeLink.offsetWidth) / 2);
        track.scrollTo({ left: Math.max(0, target), behavior: 'auto' });
      };

      track.addEventListener('wheel', (event) => {
        if (track.scrollWidth <= track.clientWidth || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        event.preventDefault();
        track.scrollBy({ left: event.deltaY, behavior: 'smooth' });
      }, { passive: false });

      track.dataset.orionSeriesReady = 'true';
      window.requestAnimationFrame(centerActiveLink);
    };

    const initializeProductMedia = (scope) => {
      scope.querySelectorAll('.orion-collection-page__card-media').forEach((media) => {
        if (media.dataset.orionMediaReady === 'true') return;
        const image = media.querySelector('img');
        if (!image) return;
        media.dataset.orionMediaReady = 'true';
        if (image.complete) return;
        media.classList.add('is-loading');
        const reveal = () => media.classList.remove('is-loading');
        image.addEventListener('load', reveal, { once: true });
        image.addEventListener('error', reveal, { once: true });
      });
    };

    const initializeInfiniteScroll = (root) => {
      const grid = root.querySelector('[data-orion-product-grid]');
      const sentinel = root.querySelector('[data-orion-infinite-scroll]');
      if (!grid || !sentinel || sentinel.dataset.orionInfiniteReady === 'true') return null;

      const fallback = sentinel.querySelector('[data-orion-infinite-fallback]');
      const status = sentinel.querySelector('[data-orion-infinite-status]');
      let nextUrl = sentinel.dataset.nextUrl;
      let observer;
      let loading = false;
      let armedByUser = true;
      let skeletonCards = [];

      const removeSkeletons = () => {
        skeletonCards.forEach((card) => card.remove());
        skeletonCards = [];
      };

      const showSkeletons = () => {
        removeSkeletons();
        const count = window.matchMedia('(max-width: 749px)').matches ? 2 : 3;
        const fragment = document.createDocumentFragment();
        skeletonCards = Array.from({ length: count }, () => {
          const card = document.createElement('li');
          card.className = 'orion-collection-page__card orion-collection-page__card--skeleton';
          card.dataset.orionSkeleton = '';
          card.setAttribute('aria-hidden', 'true');
          card.innerHTML = '<div class="orion-collection-page__skeleton-media"></div><div class="orion-collection-page__skeleton-copy"><span class="orion-collection-page__skeleton-line"></span><span class="orion-collection-page__skeleton-line orion-collection-page__skeleton-line--title"></span><span class="orion-collection-page__skeleton-line orion-collection-page__skeleton-line--price"></span></div>';
          fragment.appendChild(card);
          return card;
        });
        grid.appendChild(fragment);
      };

      const isInsideLoadZone = () => {
        const bounds = sentinel.getBoundingClientRect();
        return bounds.top <= window.innerHeight + 700 && bounds.bottom >= -700;
      };

      const armFromUserIntent = () => {
        if (loading || !nextUrl || !sentinel.isConnected) return;
        armedByUser = true;
        if (isInsideLoadZone()) loadMore();
      };

      const onKeyIntent = (event) => {
        if (['ArrowDown', 'PageDown', 'End', ' '].includes(event.key)) armFromUserIntent();
      };

      const removeIntentListeners = () => {
        window.removeEventListener('wheel', armFromUserIntent);
        window.removeEventListener('touchmove', armFromUserIntent);
        document.removeEventListener('keydown', onKeyIntent);
      };

      const loadMore = async () => {
        if (loading || !nextUrl || !armedByUser) return;
        armedByUser = false;
        loading = true;
        sentinel.dataset.state = 'loading';
        if (fallback) fallback.hidden = true;
        observer?.unobserve(sentinel);
        showSkeletons();

        try {
          const requestUrl = new URL(nextUrl, window.location.origin);
          const currentUrl = new URL(window.location.href);
          if (currentUrl.searchParams.has('preview_theme_id') && !requestUrl.searchParams.has('preview_theme_id')) {
            requestUrl.searchParams.set('preview_theme_id', currentUrl.searchParams.get('preview_theme_id'));
          }

          const response = await fetch(requestUrl.toString(), {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error(`Collection page request failed: ${response.status}`);

          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextRoot = page.querySelector('[data-orion-collection-page]');
          const nextGrid = nextRoot?.querySelector('[data-orion-product-grid]');
          if (!nextGrid) throw new Error('The next product grid was not found.');

          const cards = Array.from(nextGrid.children);
          const fragment = document.createDocumentFragment();
          cards.forEach((card) => fragment.appendChild(document.importNode(card, true)));
          removeSkeletons();
          grid.appendChild(fragment);
          initializeProductMedia(grid);
          root.dispatchEvent(new CustomEvent('orion:products-appended'));

          const nextSentinel = nextRoot.querySelector('[data-orion-infinite-scroll]');
          nextUrl = nextSentinel?.dataset.nextUrl || '';
          sentinel.dataset.nextUrl = nextUrl;
          if (fallback && nextUrl) fallback.href = `${nextUrl}#${grid.closest('section')?.id || ''}`;
          if (status) status.textContent = '';

          if (!nextUrl) {
            loading = false;
            root.dispatchEvent(new CustomEvent('orion:products-load-finished'));
            observer?.disconnect();
            removeIntentListeners();
            sentinel.remove();
            return;
          }

          loading = false;
          sentinel.dataset.state = 'idle';
          observer?.observe(sentinel);
          root.dispatchEvent(new CustomEvent('orion:products-load-finished'));
        } catch (error) {
          console.error('[Orion infinite scroll]', error);
          removeSkeletons();
          loading = false;
          sentinel.dataset.state = 'error';
          if (fallback) fallback.hidden = false;
          if (status) status.textContent = fallback?.textContent || '';
          root.dispatchEvent(new CustomEvent('orion:products-load-finished'));
        }
      };

      fallback?.addEventListener('click', (event) => {
        event.preventDefault();
        armedByUser = true;
        loadMore();
      });

      sentinel.dataset.orionInfiniteReady = 'true';
      window.addEventListener('wheel', armFromUserIntent, { passive: true });
      window.addEventListener('touchmove', armFromUserIntent, { passive: true });
      document.addEventListener('keydown', onKeyIntent);
      if ('IntersectionObserver' in window) {
        if (fallback) fallback.hidden = true;
        observer = new IntersectionObserver((entries) => {
          if (armedByUser && entries.some((entry) => entry.isIntersecting)) loadMore();
        }, { rootMargin: '700px 0px' });
        observer.observe(sentinel);
      } else {
        sentinel.dataset.state = 'manual';
        if (fallback) fallback.hidden = false;
      }

      return {
        loadAll: async () => {
          while (nextUrl) {
            if (loading) {
              await new Promise((resolve) => root.addEventListener('orion:products-load-finished', resolve, { once: true }));
              if (sentinel.dataset.state === 'error') break;
              continue;
            }
            armedByUser = true;
            await loadMore();
            if (sentinel.dataset.state === 'error') break;
          }
        }
      };
    };

    const initializePillowCategories = (root, infiniteScroll) => {
      const categoryGroup = root.querySelector('[data-orion-pillow-categories]');
      const grid = root.querySelector('[data-orion-product-grid]');
      if (!categoryGroup || !grid || categoryGroup.dataset.orionPillowCategoriesReady === 'true') return;

      const buttons = Array.from(categoryGroup.querySelectorAll('[data-orion-pillow-category]'));
      const status = root.querySelector('[data-orion-pillow-category-status]');
      const showAllLink = root.querySelector('[data-orion-pillow-show-all]');
      const resultCount = root.querySelector('[data-orion-pillow-result-count]');
      const catalog = grid.closest('.orion-collection-page__catalog');
      let activeCategory = 'all';
      let selectionVersion = 0;

      const applyCategory = (updateResultCount = false) => {
        let visibleCount = 0;
        grid.querySelectorAll('[data-orion-pillow-product]').forEach((card) => {
          const isVisible = activeCategory === 'all' || card.dataset.orionPillowProduct === activeCategory;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });
        buttons.forEach((button) => {
          const isActive = button.dataset.orionPillowCategory === activeCategory;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        const productLabel = visibleCount === 1 ? 'προϊόν' : 'προϊόντα';
        if (status) status.textContent = `${visibleCount} ${productLabel} στην επιλεγμένη κατηγορία`;
        if (updateResultCount && resultCount) resultCount.textContent = `${visibleCount} ${productLabel}`;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', async () => {
          const version = ++selectionVersion;
          activeCategory = button.dataset.orionPillowCategory || 'all';
          categoryGroup.setAttribute('aria-busy', 'true');
          buttons.forEach((categoryButton) => { categoryButton.disabled = true; });
          if (status) status.textContent = 'Φόρτωση προϊόντων';
          await infiniteScroll?.loadAll();
          if (version !== selectionVersion) return;
          applyCategory(true);
          categoryGroup.removeAttribute('aria-busy');
          buttons.forEach((categoryButton) => { categoryButton.disabled = false; });
          catalog?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });

      showAllLink?.addEventListener('click', (event) => {
        event.preventDefault();
        buttons.find((button) => button.dataset.orionPillowCategory === 'all')?.click();
      });

      root.addEventListener('orion:products-appended', applyCategory);
      categoryGroup.dataset.orionPillowCategoriesReady = 'true';
      applyCategory();
    };

    const initializeCoatingCategories = (root, infiniteScroll) => {
      const categoryGroup = root.querySelector('[data-orion-coating-categories]');
      const grid = root.querySelector('[data-orion-product-grid]');
      if (!categoryGroup || !grid || categoryGroup.dataset.orionCoatingCategoriesReady === 'true') return;

      const buttons = Array.from(categoryGroup.querySelectorAll('[data-orion-coating-category]'));
      const status = root.querySelector('[data-orion-coating-category-status]');
      const showAllLink = root.querySelector('[data-orion-coating-show-all]');
      const resultCount = root.querySelector('[data-orion-coating-result-count]');
      const catalog = grid.closest('.orion-collection-page__catalog');
      let activeCategory = 'all';
      let selectionVersion = 0;

      const applyCategory = (updateResultCount = false) => {
        let visibleCount = 0;
        grid.querySelectorAll('[data-orion-coating-product]').forEach((card) => {
          const isVisible = activeCategory === 'all' || card.dataset.orionCoatingProduct === activeCategory;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });
        buttons.forEach((button) => {
          const isActive = button.dataset.orionCoatingCategory === activeCategory;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        const productLabel = visibleCount === 1 ? 'προϊόν' : 'προϊόντα';
        if (status) status.textContent = `${visibleCount} ${productLabel} στην επιλεγμένη κατηγορία`;
        if (updateResultCount && resultCount) resultCount.textContent = `${visibleCount} ${productLabel}`;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', async () => {
          const version = ++selectionVersion;
          activeCategory = button.dataset.orionCoatingCategory || 'all';
          categoryGroup.setAttribute('aria-busy', 'true');
          buttons.forEach((categoryButton) => { categoryButton.disabled = true; });
          if (status) status.textContent = 'Φόρτωση προϊόντων';
          await infiniteScroll?.loadAll();
          if (version !== selectionVersion) return;
          applyCategory(true);
          categoryGroup.removeAttribute('aria-busy');
          buttons.forEach((categoryButton) => { categoryButton.disabled = false; });
          catalog?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });

      showAllLink?.addEventListener('click', (event) => {
        event.preventDefault();
        buttons.find((button) => button.dataset.orionCoatingCategory === 'all')?.click();
      });

      root.addEventListener('orion:products-appended', applyCategory);
      categoryGroup.dataset.orionCoatingCategoriesReady = 'true';
      applyCategory();
    };

    const initializeDuvetCategories = (root, infiniteScroll) => {
      const categoryGroup = root.querySelector('[data-orion-duvet-categories]');
      const grid = root.querySelector('[data-orion-product-grid]');
      if (!categoryGroup || !grid || categoryGroup.dataset.orionDuvetCategoriesReady === 'true') return;

      const buttons = Array.from(categoryGroup.querySelectorAll('[data-orion-duvet-category]'));
      const status = root.querySelector('[data-orion-duvet-category-status]');
      const showAllLink = root.querySelector('[data-orion-duvet-show-all]');
      const resultCount = root.querySelector('[data-orion-duvet-result-count]');
      const catalog = grid.closest('.orion-collection-page__catalog');
      let activeCategory = 'all';
      let selectionVersion = 0;

      const applyCategory = (updateResultCount = false) => {
        let visibleCount = 0;
        grid.querySelectorAll('[data-orion-duvet-product]').forEach((card) => {
          const isVisible = activeCategory === 'all' || card.dataset.orionDuvetProduct === activeCategory;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });
        buttons.forEach((button) => {
          const isActive = button.dataset.orionDuvetCategory === activeCategory;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        const productLabel = visibleCount === 1 ? 'προϊόν' : 'προϊόντα';
        if (status) status.textContent = `${visibleCount} ${productLabel} στην επιλεγμένη κατηγορία`;
        if (updateResultCount && resultCount) resultCount.textContent = `${visibleCount} ${productLabel}`;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', async () => {
          const version = ++selectionVersion;
          activeCategory = button.dataset.orionDuvetCategory || 'all';
          categoryGroup.setAttribute('aria-busy', 'true');
          buttons.forEach((categoryButton) => { categoryButton.disabled = true; });
          if (status) status.textContent = 'Φόρτωση προϊόντων';
          await infiniteScroll?.loadAll();
          if (version !== selectionVersion) return;
          applyCategory(true);
          categoryGroup.removeAttribute('aria-busy');
          buttons.forEach((categoryButton) => { categoryButton.disabled = false; });
          catalog?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });

      showAllLink?.addEventListener('click', (event) => {
        event.preventDefault();
        buttons.find((button) => button.dataset.orionDuvetCategory === 'all')?.click();
      });

      root.addEventListener('orion:products-appended', applyCategory);
      categoryGroup.dataset.orionDuvetCategoriesReady = 'true';
      applyCategory();
    };

    const initializeTopperCategories = (root, infiniteScroll) => {
      const categoryGroup = root.querySelector('[data-orion-topper-categories]');
      const grid = root.querySelector('[data-orion-product-grid]');
      if (!categoryGroup || !grid || categoryGroup.dataset.orionTopperCategoriesReady === 'true') return;

      const buttons = Array.from(categoryGroup.querySelectorAll('[data-orion-topper-category]'));
      const status = root.querySelector('[data-orion-topper-category-status]');
      const showAllLink = root.querySelector('[data-orion-topper-show-all]');
      const resultCount = root.querySelector('[data-orion-topper-result-count]');
      const catalog = grid.closest('.orion-collection-page__catalog');
      let activeCategory = 'all';
      let selectionVersion = 0;

      const applyCategory = (updateResultCount = false) => {
        let visibleCount = 0;
        grid.querySelectorAll('[data-orion-topper-product]').forEach((card) => {
          const categories = (card.dataset.orionTopperProduct || '').split(/\s+/).filter(Boolean);
          const isVisible = activeCategory === 'all' || categories.includes(activeCategory);
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });
        buttons.forEach((button) => {
          const isActive = button.dataset.orionTopperCategory === activeCategory;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        const productLabel = visibleCount === 1 ? 'προϊόν' : 'προϊόντα';
        if (status) status.textContent = `${visibleCount} ${productLabel} στην επιλεγμένη κατηγορία`;
        if (updateResultCount && resultCount) resultCount.textContent = `${visibleCount} ${productLabel}`;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', async () => {
          const version = ++selectionVersion;
          activeCategory = button.dataset.orionTopperCategory || 'all';
          categoryGroup.setAttribute('aria-busy', 'true');
          buttons.forEach((categoryButton) => { categoryButton.disabled = true; });
          if (status) status.textContent = 'Φόρτωση προϊόντων';
          await infiniteScroll?.loadAll();
          if (version !== selectionVersion) return;
          applyCategory(true);
          categoryGroup.removeAttribute('aria-busy');
          buttons.forEach((categoryButton) => { categoryButton.disabled = false; });
          catalog?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });

      showAllLink?.addEventListener('click', (event) => {
        event.preventDefault();
        buttons.find((button) => button.dataset.orionTopperCategory === 'all')?.click();
      });

      root.addEventListener('orion:products-appended', applyCategory);
      categoryGroup.dataset.orionTopperCategoriesReady = 'true';
      applyCategory();
    };

    const initializeBedCategories = (root, infiniteScroll) => {
      const categoryGroup = root.querySelector('[data-orion-bed-categories]');
      const grid = root.querySelector('[data-orion-product-grid]');
      if (!categoryGroup || !grid || categoryGroup.dataset.orionBedCategoriesReady === 'true') return;

      const buttons = Array.from(categoryGroup.querySelectorAll('[data-orion-bed-category]'));
      const status = root.querySelector('[data-orion-bed-category-status]');
      const showAllLink = root.querySelector('[data-orion-bed-show-all]');
      const resultCount = root.querySelector('[data-orion-bed-result-count]');
      const catalog = grid.closest('.orion-collection-page__catalog');
      let activeCategory = 'all';
      let selectionVersion = 0;

      const applyCategory = (updateResultCount = false) => {
        let visibleCount = 0;
        grid.querySelectorAll('[data-orion-bed-product]').forEach((card) => {
          const isVisible = activeCategory === 'all' || card.dataset.orionBedProduct === activeCategory;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });
        buttons.forEach((button) => {
          const isActive = button.dataset.orionBedCategory === activeCategory;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        const productLabel = visibleCount === 1 ? 'προϊόν' : 'προϊόντα';
        if (status) status.textContent = `${visibleCount} ${productLabel} στην επιλεγμένη κατηγορία`;
        if (updateResultCount && resultCount) resultCount.textContent = `${visibleCount} ${productLabel}`;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', async () => {
          const version = ++selectionVersion;
          activeCategory = button.dataset.orionBedCategory || 'all';
          categoryGroup.setAttribute('aria-busy', 'true');
          buttons.forEach((categoryButton) => { categoryButton.disabled = true; });
          if (status) status.textContent = 'Φόρτωση προϊόντων';
          await infiniteScroll?.loadAll();
          if (version !== selectionVersion) return;
          applyCategory(true);
          categoryGroup.removeAttribute('aria-busy');
          buttons.forEach((categoryButton) => { categoryButton.disabled = false; });
          catalog?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });

      showAllLink?.addEventListener('click', (event) => {
        event.preventDefault();
        buttons.find((button) => button.dataset.orionBedCategory === 'all')?.click();
      });

      root.addEventListener('orion:products-appended', applyCategory);
      categoryGroup.dataset.orionBedCategoriesReady = 'true';
      applyCategory();
    };

    const initializeBedBaseCategories = (root, infiniteScroll) => {
      const categoryGroup = root.querySelector('[data-orion-base-categories]');
      const grid = root.querySelector('[data-orion-product-grid]');
      if (!categoryGroup || !grid || categoryGroup.dataset.orionBaseCategoriesReady === 'true') return;

      const buttons = Array.from(categoryGroup.querySelectorAll('[data-orion-base-category]'));
      const status = root.querySelector('[data-orion-base-category-status]');
      const showAllLink = root.querySelector('[data-orion-base-show-all]');
      const resultCount = root.querySelector('[data-orion-base-result-count]');
      const catalog = grid.closest('.orion-collection-page__catalog');
      let activeCategory = 'all';
      let selectionVersion = 0;

      const applyCategory = (updateResultCount = false) => {
        let visibleCount = 0;
        grid.querySelectorAll('[data-orion-base-product]').forEach((card) => {
          const isVisible = activeCategory === 'all' || card.dataset.orionBaseProduct === activeCategory;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });
        buttons.forEach((button) => {
          const isActive = button.dataset.orionBaseCategory === activeCategory;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        const productLabel = visibleCount === 1 ? 'προϊόν' : 'προϊόντα';
        if (status) status.textContent = `${visibleCount} ${productLabel} στην επιλεγμένη κατηγορία`;
        if (updateResultCount && resultCount) resultCount.textContent = `${visibleCount} ${productLabel}`;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', async () => {
          const version = ++selectionVersion;
          activeCategory = button.dataset.orionBaseCategory || 'all';
          categoryGroup.setAttribute('aria-busy', 'true');
          buttons.forEach((categoryButton) => { categoryButton.disabled = true; });
          if (status) status.textContent = 'Φόρτωση προϊόντων';
          await infiniteScroll?.loadAll();
          if (version !== selectionVersion) return;
          applyCategory(true);
          categoryGroup.removeAttribute('aria-busy');
          buttons.forEach((categoryButton) => { categoryButton.disabled = false; });
          catalog?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });

      showAllLink?.addEventListener('click', (event) => {
        event.preventDefault();
        buttons.find((button) => button.dataset.orionBaseCategory === 'all')?.click();
      });

      root.addEventListener('orion:products-appended', applyCategory);
      categoryGroup.dataset.orionBaseCategoriesReady = 'true';
      applyCategory();
    };

    const initialize = (root) => {
      if (!root || root.dataset.orionCollectionReady === 'true') return;
      root.dataset.orionCollectionReady = 'true';
      const openButton = root.querySelector('[data-orion-filter-open]');
      const closeButtons = root.querySelectorAll('[data-orion-filter-close]');
      const panel = root.querySelector('[data-orion-filter-panel]');
      const sortMenu = root.querySelector('[data-orion-sort-menu]');
      initializeSeriesNavigation(root);
      initializeProductMedia(root);
      const infiniteScroll = initializeInfiniteScroll(root);
      initializePillowCategories(root, infiniteScroll);
      initializeCoatingCategories(root, infiniteScroll);
      initializeDuvetCategories(root, infiniteScroll);
      initializeTopperCategories(root, infiniteScroll);
      initializeBedCategories(root, infiniteScroll);
      initializeBedBaseCategories(root, infiniteScroll);
      const closeFilters = (restoreFocus = true) => {
        root.dataset.filterOpen = 'false';
        document.documentElement.classList.remove('orion-collection-filter-open');
        if (openButton) openButton.setAttribute('aria-expanded', 'false');
        if (restoreFocus && openButton) openButton.focus();
      };
      const openFilters = () => {
        root.dataset.filterOpen = 'true';
        document.documentElement.classList.add('orion-collection-filter-open');
        if (openButton) openButton.setAttribute('aria-expanded', 'true');
        const closeButton = panel ? panel.querySelector('[data-orion-filter-close]') : null;
        if (closeButton) closeButton.focus();
      };
      if (openButton) openButton.addEventListener('click', openFilters);
      closeButtons.forEach((button) => button.addEventListener('click', () => closeFilters()));
      if (sortMenu) {
        document.addEventListener('click', (event) => {
          if (sortMenu.open && !sortMenu.contains(event.target)) sortMenu.open = false;
        });
        sortMenu.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            sortMenu.open = false;
            const summary = sortMenu.querySelector('summary');
            if (summary) summary.focus();
          }
        });
      }
      root.addEventListener('keydown', (event) => { if (event.key === 'Escape' && root.dataset.filterOpen === 'true') closeFilters(); });
      window.matchMedia('(min-width: 750px)').addEventListener('change', (event) => { if (event.matches) closeFilters(false); });
    };
    document.querySelectorAll('[data-orion-collection-page]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-orion-collection-page]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-search-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.orionSearchReady === 'true') return;
      root.dataset.orionSearchReady = 'true';
      const openButton = root.querySelector('[data-orion-filter-open]');
      const panel = root.querySelector('[data-orion-filter-panel]');
      const closeButtons = root.querySelectorAll('[data-orion-filter-close]');
      const sortMenu = root.querySelector('[data-orion-sort-menu]');
      const closeFilters = (restoreFocus = true) => {
        root.dataset.filterOpen = 'false';
        document.documentElement.classList.remove('orion-search-filter-open');
        openButton?.setAttribute('aria-expanded', 'false');
        if (restoreFocus) openButton?.focus();
      };
      const openFilters = () => {
        root.dataset.filterOpen = 'true';
        document.documentElement.classList.add('orion-search-filter-open');
        openButton?.setAttribute('aria-expanded', 'true');
        panel?.querySelector('[data-orion-filter-close]')?.focus();
      };
      openButton?.addEventListener('click', openFilters);
      closeButtons.forEach((button) => button.addEventListener('click', () => closeFilters()));
      root.addEventListener('keydown', (event) => { if (event.key === 'Escape' && root.dataset.filterOpen === 'true') closeFilters(); });
      sortMenu?.addEventListener('keydown', (event) => { if (event.key === 'Escape') { sortMenu.open = false; sortMenu.querySelector('summary')?.focus(); } });
      document.addEventListener('click', (event) => { if (sortMenu?.open && !sortMenu.contains(event.target)) sortMenu.open = false; });

      const grid = root.querySelector('[data-orion-search-grid]');
      const sentinel = root.querySelector('[data-orion-infinite-scroll]');
      if (!grid || !sentinel) return;
      const fallback = sentinel.querySelector('[data-orion-infinite-fallback]');
      const status = sentinel.querySelector('[data-orion-infinite-status]');
      let nextUrl = sentinel.dataset.nextUrl;
      let loading = false;
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadNext();
      }, { rootMargin:'500px 0px' }) : null;
      const loadNext = async () => {
        if (loading || !nextUrl) return;
        loading = true;
        sentinel.dataset.state = 'loading';
        if (status) status.textContent = 'Φόρτωση περισσότερων αποτελεσμάτων';
        try {
          const response = await fetch(nextUrl, { headers:{ 'X-Requested-With':'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const nextRoot = documentFragment.querySelector('[data-orion-search-page]');
          const nextGrid = nextRoot?.querySelector('[data-orion-search-grid]');
          if (!nextGrid) throw new Error('Missing results');
          [...nextGrid.children].forEach((card) => grid.appendChild(card));
          const nextSentinel = nextRoot.querySelector('[data-orion-infinite-scroll]');
          nextUrl = nextSentinel?.dataset.nextUrl || '';
          sentinel.dataset.nextUrl = nextUrl;
          if (status) status.textContent = nextUrl ? 'Φορτώθηκαν περισσότερα αποτελέσματα' : 'Όλα τα αποτελέσματα έχουν φορτωθεί';
          if (!nextUrl) {
            observer?.disconnect();
            sentinel.remove();
          } else {
            sentinel.dataset.state = 'ready';
          }
        } catch (error) {
          sentinel.dataset.state = 'error';
          if (status) status.textContent = 'Δεν ήταν δυνατή η φόρτωση περισσότερων αποτελεσμάτων';
          if (fallback) fallback.hidden = false;
        } finally {
          loading = false;
        }
      };
      if (observer) observer.observe(sentinel);
      else sentinel.dataset.state = 'manual';
    };
    document.querySelectorAll('[data-orion-search-page]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-orion-search-page]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
